import React, { useState } from "react"
import { useLocation } from "react-router-dom"

import Table from "components/Table"
import Filter from "@Components/Filter"

import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline"
import BlockIcon from "@material-ui/icons/Block"


import { STORAGE_CONSTANT,USER_STATUS} from "../../configs/constants.js"
import eightAxios from "../../configs/axiosConfig.js"
import { useNotifyContext } from "@Components/Notify"

let model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "mobile_number", label: "Mobile Number", type: "string" },
  { id: "role", label: "Role", type: "string" },
  { id: "ur_status", label: "User Request Status", type: "string" },
  { id: "request_datetime", label: "Request Date & Time", type: "string" },
]
const pageNumberDropdown = true
let actionPermission = true;

const status = [
  {
    id: "Open",
    name: "OPEN",
  },
  {
    id: "Closed",
    name: "CLOSED",
  },
]

const filterFields = [
  {
    type: "datepicker",
    label: "From Date",
    name: "from_date",
    required: true,
  },
  {
    type: "datepicker",
    label: "To Date",
    name: "to_date",
    required: true,
  },
  {
    type: "reactselect",
    label: "Status",
    name: "status",
    outerOptions: status,
  },
]
const today = new Date()
const options = { timeZone: 'Asia/Kuala_Lumpur' }
let date = today.toLocaleDateString('en-GB', options)
date = date.split('/').reverse().join('-')

const filterInitialValues = {
  from_date: date,
  to_date: date,
  status: "",
}

const AccountDeletionList = () => {
  const [filterValues, setFilterValues] = useState(filterInitialValues)
  const [filtersApplied, setFiltersApplied] = useState(false)


  const [loading, setLoading] = useState(false)
  const [onError, setOnError] = useState({})
  const [confirmDialog, setConfirmDialog] = useState({
     isOpen: false,
     title: "",
     subTitle: "",
   })
   
   const setNotify = useNotifyContext()

  const details = useLocation()
  let filters = {}

  if ("searchParams" in details) {
    if (details.searchParams.from_date.dateForAPI) {
      filters["from_date"] = details.searchParams.from_date.dateForAPI
    }
    if (details.searchParams.to_date.dateForAPI) {
      filters["to_date"] = details.searchParams.to_date.dateForAPI
    }
    if (details.searchParams.status) {
      filters["status"] = details.searchParams.status
    }
  }

  const onFilterRequest = (values) => {
    setFiltersApplied(true)

    let filterObj = {}
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value
      }
    }
    setFilterValues(filterObj)
  }
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload()
   }


   const deleteUserByRequest = (id,employee_id, mobile_number) =>{
     setLoading(true)
    eightAxios
          //  .delete(`${proxyURL}${id}/`)
          // .delete(`approve-delete/${id}/${employee_id}/${mobile_number}/`)
          .delete(`approve-request/${id}/`)
           .then(() => {
             setConfirmDialog({
               ...confirmDialog,
               isOpen: false,
             })
             setNotify({
               isOpen: true,
               message: "User is successfully deleted",
               type: "success",
             })
           })
           .catch((error) => {         
             setNotify({
               isOpen: true,
               message: error.response.data.message,
               type: "error",
             })
           })   
    
  }

  const rejectDeleteRequest = (id) => {
    eightAxios
    .delete(`reject-request/${id}/`)
    .then(() => {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      })
      setNotify({
        isOpen: true,
        message: "User has been rejected.",
        type: "success",
      })
    })
    .catch((error) => {
      setNotify({
        isOpen: true,
        message: error.response.data.message,
        type: "error",
      })
    }) 
  }
   const actions = [
    {
      type: "approve",
      title: "Approve",
      icon: (
        <CheckCircleOutline style={{ color: actionPermission ? "green" : "gray" }} />
      ), 
      onClick: (id,employee_id) => {
        {actionPermission && deleteUserByRequest(id,employee_id.employee_id, employee_id.mobile_number)}
      },
    },
    {
      type: "reject",
      title: "Reject",
      icon: (
        <BlockIcon style={{ color: actionPermission ? "red" : "gray" }} />
      ),
      onClick: (id, record) => {
        {actionPermission && rejectDeleteRequest(id)}
      },
    },
  ]

  
  const validateAction =()=>{
  const updatedModules = JSON.parse(localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES));

    if (updatedModules) {
      if(updatedModules["Delete Account Request"].includes("edit")){
        actionPermission = true;
      }else actionPermission = false
    }
  }

  validateAction()

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
        onClear={clearFilter}

        
      />
            {filtersApplied ? (

      <Table
        proxyURL="account-deletion/"
        model={model}
        filterValues={filterValues}
        pageNumberDropdown={pageNumberDropdown}
         actions={actions}
        noFilter
        linkUrlName='/view-details/'

      />
            ) : (
<Table
        proxyURL={null}
        model={model}
        filterValues={filterValues}
        pageNumberDropdown={pageNumberDropdown}
        actions={actions}
        noFilter
        linkUrlName='/view-details/'

      />
      )}

    </>
  )
}
export default AccountDeletionList
